import {createContext, getContextOrThrow} from 'src/core';
import type {Readable, Writable} from 'svelte/store';
import type {CellCoordinates} from '../types';
import {distinctStore} from 'shared/utils/store-utils';

const GRID_CELL_CONTEXT_KEY = Symbol('grid-cell-context-key');

type ContentDependentState = Record<'invalid' | 'disabled' | 'readOnly', boolean>;

interface GridCellContext {
    coordinates$: Readable<CellCoordinates>;
    contentDependentState$: Writable<ContentDependentState>;
}

export function setGridCellContext(coordinates$: Readable<CellCoordinates>): GridCellContext {
    return createContext(GRID_CELL_CONTEXT_KEY, {
        coordinates$,
        contentDependentState$: distinctStore({disabled: false, invalid: false, readOnly: false})
    });
}

export function getGridCellContext(): GridCellContext {
    return getContextOrThrow(GRID_CELL_CONTEXT_KEY);
}